/** Local static assets grouped by route — used for preload / prefetch. */

export const GLOBAL_CRITICAL = [
  '/logo-mark.svg',
  '/logo-wordmark.webp?v=2'
];

export const HOME_ASSETS = [
  '/lobby/promo-bg.webp?v=8',
  '/lobby/lobby-live.webp?v=16',
  '/lobby/lobby-leagues.webp?v=15',
  '/lobby/lobby-scores.webp?v=15',
  '/lobby/lobby-news.webp?v=15'
];

export const ONBOARDING_ASSETS = ['/lobby/ob-ball.webp?v=5', '/logo-wordmark.webp?v=2'];

export const NEWS_COVERS = [
  '/news/premier.webp',
  '/news/laliga.webp',
  '/news/seriea.webp',
  '/news/cl.webp',
  '/news/preseason.webp',
  '/news/transfers.webp',
  '/news/tactics.webp',
  '/news/women.webp'
];

export const PLACEHOLDER_LOGOS = [
  '/default-team-logo.svg',
  '/default-league-logo.svg'
];

/** High-priority assets per route prefix (first segment match). */
export function assetsForPath(pathname = '/') {
  if (pathname === '/onboarding') {
    return { high: ONBOARDING_ASSETS, low: HOME_ASSETS.slice(0, 2) };
  }
  if (pathname === '/paywall' || pathname.startsWith('/paywall/')) {
    return { high: ['/logo-wordmark.webp?v=2'], low: [] };
  }
  if (pathname === '/news') {
    return { high: NEWS_COVERS.slice(0, 2), low: NEWS_COVERS.slice(2) };
  }
  if (pathname.startsWith('/news/')) {
    return { high: [], low: NEWS_COVERS.slice(0, 4) };
  }
  if (pathname.startsWith('/match/')) {
    return { high: PLACEHOLDER_LOGOS, low: [] };
  }
  if (pathname === '/' || pathname === '/streams' || pathname === '/scores') {
    return {
      high: [HOME_ASSETS[0], ...PLACEHOLDER_LOGOS],
      low: HOME_ASSETS.slice(1)
    };
  }
  return { high: PLACEHOLDER_LOGOS, low: [] };
}

/** Idle prefetch when user lands on a hub page. */
export function prefetchTargetsForPath(pathname = '/') {
  if (pathname === '/') return { routes: ['/news'], assets: ONBOARDING_ASSETS };
  if (pathname === '/streams' || pathname === '/scores') {
    return { routes: [], assets: HOME_ASSETS.slice(1, 3) };
  }
  return { routes: [], assets: [] };
}
